import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener, ChangeDetectionStrategy
} from "@angular/core";
import { PROUTES } from './patient/vertical-menu-routes.config';

import { MROUTES } from './merchant/vertical-menu-routes.config';

import { getAlldata } from './Invoice/DigiSparsh-sidebar-routes.config';
import { getAlldata1 } from './Invoice/hospital-sidebar-routes-config';
import { getAlldata7 } from './Invoice/distributor-sidebar-routes-config';
import { getAlldata2 } from './Invoice/lender-sidebar-routes.config';
import { getAlldata3 } from './Invoice/aggregator-sidebar-routes.config';
import { getAlldata4 } from './Invoice/supplier-sidebar-route';
import { getAlldata5 } from './patient/business-partner-routes.config';
import { getAlldata6 } from './patient/patient-sidebar-routes.config';
import { purchaseFinancing } from './Invoice/pharmacy-sidebar-routes.config';

// import { hsROUTES } from './Invoice/hospital-sidebar-routes-config';
import { vsROUTES } from './Invoice/validator-sidebar-routes.config';
// import { spROUTES } from './Invoice/supplier-sidebar-route';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  // public menuItems1: any[];
  typeOfOrganization = sessionStorage.getItem('typeOfOrganization')
  claimFinancing = sessionStorage.getItem('claimFinancing')
  supplierFinancing = sessionStorage.getItem('supplierFinancing')
  patientFinancing = sessionStorage.getItem('patientFinancing')
  merchantFinancing = sessionStorage.getItem('merchantFinancing')
  employeeManagement = sessionStorage.getItem('employeeManagement')
  purchaseFinancing = sessionStorage.getItem('purchaseFinancing')
  distributor = sessionStorage.getItem('distributor')

  level: number = 0;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  // menuItems1: void;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,

    private deviceService: DeviceDetectorService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  async ngOnInit() {

    console.log(this.typeOfOrganization)
    switch (this.typeOfOrganization) {
      case 'Digisparsh': { this.menuItems = await getAlldata(); break; }
      case 'Hospital': { this.menuItems = await getAlldata1(); break; }
      case 'Distributor': { this.menuItems =  await getAlldata7(); break;}
      case 'Lender': { this.menuItems = await getAlldata2(); break; }
      case 'Aggregator': { this.menuItems = await getAlldata3(); break; }
      case 'Vendor': {this.menuItems = await getAlldata4();  break; }
      case 'Business Partner': { this.menuItems = await getAlldata5(); break; }
      case 'Processing Partner': { this.menuItems = await getAlldata6(); break; }
      // case 'Distributor': {if(this.purchaseFinancing&&this.purchaseFinancing=='true'){this.menuItems = await purchaseFinancing();}}
      case 'Pmanufacture':  {if(this.purchaseFinancing&&this.purchaseFinancing=='true'){this.menuItems = await purchaseFinancing();}}


      // case 'Aggregator': { this.menuItems = agROUTES; break; }
      // case 'Hospital': { this.menuItems = hsROUTES; break; }
      // case 'Lender': { this.menuItems = lsROUTES; break; }
      // case 'Vendor': { this.menuItems = spROUTES; break; }
      // case 'Merchant': {this.menuItems = MROUTES; break;}
    }



  }

  ngAfterViewInit() {

    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();

    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      });

  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {

    if (this.config.layout.menuPosition === "Top") { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        this.menuItems = HROUTES;
      }
    }


    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    }
    else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    }
    else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {

    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    }
    else {
      this.perfectScrollbarEnable = true;
    }

  }


  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }

  }


}
